import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import fatcaQuestionnaireType from '../../life-config/fatcaQuestionConfig.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { ApiService } from '../../services/api.service';
import { map, startWith } from 'rxjs/operators';
import { SharedApiService } from '../../services/shared-api.service';
import { CountryInfo } from '../../model/data.model';
import trackingInfo from '../../life-config/journey-tracker.json';

@Component({
    selector: 'app-tata-occupation',
    templateUrl: './tata-occupation.component.html',
    styleUrls: ['./tata-occupation.component.css']
  })
export class TataOccupationComponent implements OnInit {

    occQuestionnaireForm: FormGroup;
    fatcaQuestionnaireDetails: object = fatcaQuestionnaireType.FatcaQuestionnaireFormInitialJson;
    covidQuestionnaireDetails: object = fatcaQuestionnaireType.covidQuestion;
    defenceQuestionnaireDetails: object = fatcaQuestionnaireType.defenceQuestion;
    occupationQuestionnaireDetails: object = fatcaQuestionnaireType.occupationQuestion;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    trackInfo: object = trackingInfo['tracker-info'];
    birthCountryList: any;
    citizenCountryList: any;
    companyList: any;
    addressCountryList: any;
    taxResidencyCountry: any;
    addressStateList: any;
    addResidencyState: any;
    addressCityList: any;
    addressPincode: any;
    mergedCovidData: any;
    defenceData: any;
    occupdationData: any;
    proposalRes: any;
    fatcaData: any;
    finalDataToSend: any;
    tabListData: any;
    isLeftSectionLoader = false;
    isLoaderActivated = false;
    // residence_tax : any;

    uuid: string;
    proposalId: string;
    productType: object = lifeProductType.product_type;

    constructor(
                private apiService: ApiService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private datePipe: DatePipe,
                private sharedData: SharedApiService,
                private formbuild: FormBuilder) {
                this.occQuestionnaireForm = this.formbuild.group({

                    /**
                     * Occupation
                     */

                    exactOccupation: ['', [
                        Validators.maxLength(100),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))]],
                    jobResponsibilities: ['', [
                        Validators.required,
                        Validators.maxLength(100),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))]],
                    engagedOccupation: ['', [
                        Validators.required,
                        Validators.maxLength(100),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))]],
                    adminPercentage: ['', [
                        Validators.required,
                        Validators.maxLength(15),
                        Validators.pattern(new RegExp('^[0-9 ]*$'))]],
                    superVisorPercentage: ['', [
                        Validators.required,
                        Validators.maxLength(15),  Validators.pattern(new RegExp('^[0-9 ]*$'))] ] ,
                    manualLabourPercentage: ['', [
                        Validators.required,
                        Validators.maxLength(15),  Validators.pattern(new RegExp('^[0-9 ]*$'))] ] ,
                    travelPercentage: ['', [Validators.required,Validators.maxLength(15),  Validators.pattern(new RegExp('^[0-9 ]*$'))] ] ,
                    indoorOutdoor: [this.occupationQuestionnaireDetails['indoorOutdoor']['default']],
                    indoorOutdoorDesc: [],
                    machineOperator: [this.occupationQuestionnaireDetails['machineOperator']['default']],
                    machineOperatorDesc: [],
                    workHeight: [this.occupationQuestionnaireDetails['workHeight']['default']],
                    workHeightDesc: [],
                    workOffshore: [ this.occupationQuestionnaireDetails['workOffshore']['default']],
                    workOffshoreDesc: [],
                    dutyAccident: [this.occupationQuestionnaireDetails['dutyAccident']['default']],
                    dutyAccidentDesc: [],
                    driveTwoWheeler: [this.occupationQuestionnaireDetails['driveTwoWheeler']['default']],
                    driveTwoWheelerDesc: [],
                    hazardousOCC: [this.occupationQuestionnaireDetails['hazardousOCC']['default']],
                    hazardousOCCDesc: [],
                    acceptDeclaration: []

                });

                this.sharedData.tabEventData.subscribe(value => {
                    if (value) {

                        this.tabListData = value;


                    }
                });

                this.apiService.getStatusEvent.subscribe(value => {

                    if (value) {
                        const errorStatusFromApi = value['status'];

                        if ( errorStatusFromApi === 400 ) {

                            this.isLoaderActivated = false;
                        }
                    }


                });
    }


    /**
     * Feed proposal data
     */

    feedProposalData() {

        this.tabListData = this.sharedData.storeTabInfo();
        /**
         * Occupation
         */


        this.occQuestionnaireForm.patchValue({ exactOccupation: this.proposalRes['questions']['exact_occupation'] });

        // this.occQuestionnaireForm.patchValue({ nature_of_duty: this.proposalRes['questions']['exact_occupation'] });
        this.occQuestionnaireForm.patchValue({ jobResponsibilities: this.proposalRes['questions']['nature_of_duty'] });
        this.occQuestionnaireForm.patchValue({ engagedOccupation: this.proposalRes['questions']['engaged_occupation'] });
        this.occQuestionnaireForm.patchValue({ adminPercentage: this.proposalRes['questions']['admin_percentage'] });
        this.occQuestionnaireForm.patchValue({ superVisorPercentage: this.proposalRes['questions']['supervisor_percentage'] });
        this.occQuestionnaireForm.patchValue({ manualLabourPercentage: this.proposalRes['questions']['labour_percentage'] });
        this.occQuestionnaireForm.patchValue({ travelPercentage: this.proposalRes['questions']['travel_percentage'] });
        this.occQuestionnaireForm.patchValue({ indoorOutdoor: this.proposalRes['questions']['indoor_outdoor'] });

        if ( this.proposalRes['questions']['indoor_outdoor']) {

            this.occQuestionnaireForm.patchValue({ indoorOutdoorDesc: this.proposalRes['questions']['indoor_outdoor_detail'] });
        }

        this.occQuestionnaireForm.patchValue({ machineOperator: this.proposalRes['questions']['operation_machine'] });

        if ( this.proposalRes['questions']['operation_machine']  ) {

            this.occQuestionnaireForm.patchValue({ machineOperatorDesc: this.proposalRes['questions']['operation_machine_detail'] });

        }

        this.occQuestionnaireForm.patchValue({ workHeight: this.proposalRes['questions']['work_at_heights'] });

        if ( this.proposalRes['questions']['work_at_heights']) {

            this.occQuestionnaireForm.patchValue({ workHeightDesc: this.proposalRes['questions']['work_at_heights_detail'] });

        }

        this.occQuestionnaireForm.patchValue({ workOffshore: this.proposalRes['questions']['work_underground'] });

        if ( this.proposalRes['questions']['work_underground'] ) {

            this.occQuestionnaireForm.patchValue({ workOffshoreDesc: this.proposalRes['questions']['work_underground_detail'] });
        }

        this.occQuestionnaireForm.patchValue({ dutyAccident: this.proposalRes['questions']['accident_illness'] });

        if ( this.proposalRes['questions']['accident_illness']) {

            this.occQuestionnaireForm.patchValue({ dutyAccidentDesc: this.proposalRes['questions']['accident_illness_detail'] });

        }

        this.occQuestionnaireForm.patchValue({ driveTwoWheeler: this.proposalRes['questions']['drive_vehicle'] });

        if (this.proposalRes['questions']['drive_vehicle']) {

            this.occQuestionnaireForm.patchValue({ driveTwoWheelerDesc: this.proposalRes['questions']['kilometers'] });

        }

        this.occQuestionnaireForm.patchValue({ hazardousOCC: this.proposalRes['questions']['occupation_hazardous'] });

        if (this.proposalRes['questions']['occupation_hazardous']) {

            this.occQuestionnaireForm.patchValue({ hazardousOCCDesc: this.proposalRes['questions']['occupation_hazardous_detail'] });

        }

        this.isLeftSectionLoader = false;
    }

    indoorOutdoorValidation() {

        // Smoke
        const indoorOutdoorInfo = this.occQuestionnaireForm.get('indoorOutdoorDesc');
        this.occQuestionnaireForm.get('indoorOutdoor').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if (weightGainMode === true) {


                    indoorOutdoorInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [
                            Validators.required,
                            Validators.maxLength(100),
                        ]
                    );
                }
                if (weightGainMode === false) {

                    indoorOutdoorInfo.setValidators(null);

                }

                indoorOutdoorInfo.updateValueAndValidity();

            });
    }


   machineOperationValidation() {

        // Smoke
        const indoorOutdoorInfo = this.occQuestionnaireForm.get('machineOperatorDesc');
        this.occQuestionnaireForm.get('machineOperator').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if (weightGainMode === true) {


                    indoorOutdoorInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [
                            Validators.required,
                            Validators.maxLength(100),
                        ]
                    );
                }
                if (weightGainMode === false) {

                    indoorOutdoorInfo.setValidators(null);

                }

                indoorOutdoorInfo.updateValueAndValidity();

            });
    }


    workHeightsValdation() {

        // Smoke
        const indoorOutdoorInfo = this.occQuestionnaireForm.get('workHeightDesc');
        this.occQuestionnaireForm.get('workHeight').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if (weightGainMode === true) {


                    indoorOutdoorInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [
                            Validators.required,
                            Validators.maxLength(100),
                        ]
                    );
                }
                if (weightGainMode === false) {

                    indoorOutdoorInfo.setValidators(null);

                }

                indoorOutdoorInfo.updateValueAndValidity();

            });
    }

    workOffShoreValdation() {

        // Smoke
        const indoorOutdoorInfo = this.occQuestionnaireForm.get('workOffshoreDesc');
        this.occQuestionnaireForm.get('workOffshore').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if (weightGainMode === true) {


                    indoorOutdoorInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [
                            Validators.required,
                            Validators.maxLength(100),
                        ]
                    );
                }
                if (weightGainMode === false) {

                    indoorOutdoorInfo.setValidators(null);

                }

                indoorOutdoorInfo.updateValueAndValidity();

            });
    }

    dutyAccidentValdation() {

        // Smoke
        const indoorOutdoorInfo = this.occQuestionnaireForm.get('dutyAccidentDesc');
        this.occQuestionnaireForm.get('dutyAccident').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if (weightGainMode === true) {


                    indoorOutdoorInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [
                            Validators.required,
                            Validators.maxLength(100),
                        ]
                    );
                }
                if (weightGainMode === false) {

                    indoorOutdoorInfo.setValidators(null);

                }

                indoorOutdoorInfo.updateValueAndValidity();

            });
    }

    driveTwoWheelerValdation() {

        // Smoke
        const indoorOutdoorInfo = this.occQuestionnaireForm.get('driveTwoWheelerDesc');
        this.occQuestionnaireForm.get('driveTwoWheeler').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if (weightGainMode === true) {


                    indoorOutdoorInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [
                            Validators.required,
                            Validators.max(100),
                        ]
                    );
                }
                if (weightGainMode === false) {

                    indoorOutdoorInfo.setValidators(null);

                }

                indoorOutdoorInfo.updateValueAndValidity();

            });
    }

    hazardousOCCValdation() {

        // Smoke
        const indoorOutdoorInfo = this.occQuestionnaireForm.get('hazardousOCCDesc');
        this.occQuestionnaireForm.get('hazardousOCC').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if (weightGainMode === true) {


                    indoorOutdoorInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [
                            Validators.required,
                            Validators.maxLength(100),
                        ]
                    );
                }
                if (weightGainMode === false) {

                    indoorOutdoorInfo.setValidators(null);

                }

                indoorOutdoorInfo.updateValueAndValidity();

            });
    }

    /** Save Form data */

    saveOccupationFormData(isValid: boolean, event) {

        if (isValid) {

                this.isLoaderActivated = true;
                const occupdationDate = {

                    exact_occupation: this.occQuestionnaireForm.get('exactOccupation').value,
                    nature_of_duty: this.occQuestionnaireForm.get('jobResponsibilities').value,
                    engaged_occupation: this.occQuestionnaireForm.get('engagedOccupation').value,

                    admin_percentage: parseInt(this.occQuestionnaireForm.get('adminPercentage').value),
                    supervisor_percentage: parseInt(this.occQuestionnaireForm.get('superVisorPercentage').value),
                    labour_percentage: parseInt(this.occQuestionnaireForm.get('manualLabourPercentage').value),
                    travel_percentage: parseInt(this.occQuestionnaireForm.get('travelPercentage').value),
                    indoor_outdoor: this.occQuestionnaireForm.get('indoorOutdoor').value,
                    operation_machine: this.occQuestionnaireForm.get('machineOperator').value,
                    work_at_heights: this.occQuestionnaireForm.get('workHeight').value,
                    work_underground: this.occQuestionnaireForm.get('workOffshore').value,
                    drive_vehicle: this.occQuestionnaireForm.get('driveTwoWheeler').value,
                    occupation_hazardous : this.occQuestionnaireForm.get('hazardousOCC').value,
                    accident_illness: this.occQuestionnaireForm.get('dutyAccident').value,



                };

                this.occupdationData = occupdationDate;

                if (this.occQuestionnaireForm.get('indoorOutdoor').value === true) {

                    const covidSympDesc = {

                        indoor_outdoor_detail: this.occQuestionnaireForm.get('indoorOutdoorDesc').value



                    };


                    this.occupdationData = Object.assign({}, this.occupdationData, covidSympDesc);
                }


                if (this.occQuestionnaireForm.get('machineOperator').value === true) {

                    const covidSympDesc = {

                        operation_machine_detail: this.occQuestionnaireForm.get('machineOperatorDesc').value



                    };


                    this.occupdationData = Object.assign({}, this.occupdationData, covidSympDesc);
                }

                if (this.occQuestionnaireForm.get('workHeight').value === true) {

                    const covidSympDesc = {

                        work_at_heights_detail: this.occQuestionnaireForm.get('workHeightDesc').value



                    };


                    this.occupdationData = Object.assign({}, this.occupdationData, covidSympDesc);
                }

                if (this.occQuestionnaireForm.get('workOffshore').value === true) {

                    const covidSympDesc = {

                        work_underground_detail: this.occQuestionnaireForm.get('workOffshoreDesc').value



                    };


                    this.occupdationData = Object.assign({}, this.occupdationData, covidSympDesc);
                }

                if (this.occQuestionnaireForm.get('dutyAccident').value === true) {

                    const covidSympDesc = {

                        accident_illness_detail: this.occQuestionnaireForm.get('dutyAccidentDesc').value



                    };


                    this.occupdationData = Object.assign({}, this.occupdationData, covidSympDesc);
                }

                if (this.occQuestionnaireForm.get('driveTwoWheeler').value === true) {

                    const covidSympDesc = {

                        kilometers: this.occQuestionnaireForm.get('driveTwoWheelerDesc').value


                    };


                    this.occupdationData = Object.assign({}, this.occupdationData, covidSympDesc);
                }


                if (this.occQuestionnaireForm.get('hazardousOCC').value === true) {

                    const covidSympDesc = {

                        occupation_hazardous_detail: this.occQuestionnaireForm.get('hazardousOCCDesc').value


                    };


                    this.occupdationData = Object.assign({}, this.occupdationData, covidSympDesc);
                }






                const mergedObjectInfoData: any = {

                questions: Object.assign({},   this.occupdationData),
                journey_track: this.trackInfo['QUESTIONNAIRE']
            };

                this.finalDataToSend =  Object.assign({}, mergedObjectInfoData);

            /** Invoking api serices -Update proposal */

                this.apiService.updateProposal(
                this.apiUrl['apiV2LifeProposal'],
                this.proposalId, this.uuid,
                this.apiUrl['update_proposal'],
                this.finalDataToSend).subscribe(res => {

                if (res) {

                    this.isLoaderActivated = false;
                    
                    if (this.tabListData && this.tabListData.length > 1) {

                        this.tabListData.forEach((element, index) => {
                            if (element['type'] === 'occupation') {

                                /**
                                 * check for mas array size
                                 * if list attains max size in that case tab movment will be stopped 
                                 * and leads to next module
                                 */

                                if(index < (this.tabListData.length) - 1) {

                                    this.sharedData.getNextCrntActiveTab(this.tabListData[index + 1] , 0);
                                } else {
                                    
                                    this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                                }
                            }

                         });




                    } else {

                        this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                    }
                }

            },
                err => {
                    console.log('sonething went at our end', err);
                });

        }
    }


    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.proposalId = params['proposalId'];
        });

        // Get propsoal info

        if (this.uuid && this.proposalId) {

            this.isLeftSectionLoader = true;
            this.sharedData.getProposalInfo(this.proposalId, this.uuid).subscribe(res => {
                if (res) {

                    this.proposalRes = res;


                    if (this.proposalRes) {

                        this.feedProposalData();
                        this.indoorOutdoorValidation();
                        this.machineOperationValidation();
                        this.workHeightsValdation();
                        this.workOffShoreValdation();
                        this.dutyAccidentValdation();
                        this.driveTwoWheelerValdation();
                        this.hazardousOCCValdation();

                    }
                }

            });

        }
    }



    /**
     * Back btn
     */



    backBtnFromRoutes() {
        this.router.navigate(['/life/upload-document', this.proposalId, this.uuid])
        .then(() => {
            window.location.reload();
        });

    }

}

